var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBillon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161.092,
    height: 30.518,
    viewBox: "0 0 161.092 30.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60d170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00adff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(-86.176 -97.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M156.5,102.279a7.8,7.8,0,0,0-7-4.382c-2.353.038-6.85,1.244-10.562,8.9a41.7,41.7,0,0,1-4.343,7.213,14.607,14.607,0,0,1-4.573-3.444c-.938-.995-2.43-2.717-2.43-2.717l-.325-.325c-4.535-5.931-10.791-9.165-17.66-9.165h-.421a25.3,25.3,0,0,0-19.574,10.466c-4.305,6.123-3.961,11.863-2.2,15.192a7.77,7.77,0,0,0,6.869,4.382h.134c2.353-.038,6.85-1.244,10.562-8.9a45.739,45.739,0,0,1,3.214-5.625c3.559-.938,5.262.842,8.266,4.42.1.115.21.249.325.383,5.874,7.826,12.762,9.529,17.622,9.529h.306c7.4-.115,15.1-4.324,19.612-10.734C158.6,111.348,158.258,105.608,156.5,102.279Zm-46.3,8.821c1.722-1.779,4.477-3.884,6.6-4.343,2.7-.593,5.53.325,8.457,2.736,0,0,1.913,1.952,2.813,2.908a19.526,19.526,0,0,0,4.611,3.827,11.3,11.3,0,0,1-5.434,3.291c-2.6.574-5.357-.287-8.208-2.564-.1-.1-.191-.191-.306-.287-2.047-2.411-4.267-5.3-6.85-5.587A4.229,4.229,0,0,0,110.194,111.1Zm-7.787,7.156c-2.239,4.592-5.166,7.252-8.055,7.309a4.945,4.945,0,0,1-4.439-2.87c-1.358-2.583-1.55-7.156,2.028-12.226a22.4,22.4,0,0,1,17.3-9.28h.383a18.052,18.052,0,0,1,9.356,2.564,9.8,9.8,0,0,0-2.794.23C111.112,105.072,106.482,109.875,102.406,118.256Zm49.556-2.411c-4,5.683-10.811,9.433-17.316,9.529a17.268,17.268,0,0,1-9.911-2.908,10.668,10.668,0,0,0,3.119-.191c5.013-1.091,9.605-5.874,13.662-14.216,2.239-4.592,5.166-7.252,8.055-7.309a4.924,4.924,0,0,1,4.439,2.87C155.349,106.182,155.541,110.755,151.963,115.845Z",
    transform: "translate(0 -0.078)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(172.091 97.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M535.2,99.388a1.627,1.627,0,0,1,3.253,0v8.9a9.138,9.138,0,0,1,5.53-1.7c4.745,0,6.448,2.832,6.448,6.486v7.807c0,4.152-2.526,7.4-7.615,7.4-4.822,0-7.615-2.908-7.615-6.563Zm3.234,22.329c0,2.239,1.665,3.578,4.362,3.578,2.985,0,4.362-1.665,4.362-4.4v-7.807c0-2.3-1.205-3.655-4-3.655a6.02,6.02,0,0,0-4.745,2.086v10.2Z",
    transform: "translate(-535.2 -97.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M633.89,103.88a1.988,1.988,0,0,1-1.99-1.99,1.99,1.99,0,0,1,3.98,0A1.988,1.988,0,0,1,633.89,103.88Zm0,26.1a1.6,1.6,0,0,1-1.626-1.626v-18.33a1.626,1.626,0,1,1,3.253,0v18.33A1.6,1.6,0,0,1,633.89,129.978Z",
    transform: "translate(-613.398 -99.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M676.4,99.426a1.625,1.625,0,0,1,1.626-1.626,1.6,1.6,0,0,1,1.626,1.626v24.625a2.406,2.406,0,0,0,.574,1.952,1.34,1.34,0,0,1,.287.8,1.494,1.494,0,0,1-1.492,1.492c-1.033,0-2.621-.5-2.621-4.248Z",
    transform: "translate(-649.383 -97.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M717.3,99.426a1.625,1.625,0,0,1,1.626-1.626,1.6,1.6,0,0,1,1.626,1.626v24.625a2.406,2.406,0,0,0,.574,1.952,1.34,1.34,0,0,1,.287.8,1.494,1.494,0,0,1-1.492,1.492c-1.033,0-2.621-.5-2.621-4.248Z",
    transform: "translate(-682.458 -97.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M751.8,157.85V150.9c0-4.152,2.7-7.4,7.768-7.4s7.768,3.234,7.768,7.4v6.946c0,4.152-2.7,7.4-7.768,7.4C754.5,165.236,751.8,162,751.8,157.85Zm12.3,0v-6.984c0-2.7-1.531-4.363-4.535-4.363-2.985,0-4.535,1.665-4.535,4.363v6.984c0,2.736,1.531,4.4,4.535,4.4S764.1,160.586,764.1,157.85Z",
    transform: "translate(-710.356 -134.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M849.686,164.114a1.627,1.627,0,0,1-3.253,0v-14.14c0-2.3-.383-2.3-.746-2.908a1.7,1.7,0,0,1-.287-.842,1.472,1.472,0,0,1,1.531-1.454,2.113,2.113,0,0,1,1.741,1.205,10.413,10.413,0,0,1,5.951-1.875c4.4,0,6.6,3.157,6.6,7.864v12.15a1.5,1.5,0,0,1-1.626,1.569,1.522,1.522,0,0,1-1.626-1.569v-12.15c0-3.157-1.339-4.956-3.827-4.956a7.717,7.717,0,0,0-4.611,1.741,7.454,7.454,0,0,1,.115,1.205v14.159Z",
    transform: "translate(-786.047 -135.241)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBillon);
export default __webpack_public_path__ + "static/media/Logo-Billon.be86c5181624c5135e1f750e963b7632.svg";
export { ForwardRef as ReactComponent };